export default class Endereco {
  endereco = {
    value: '',
    maxlength: '50',
    required: true,
    state: null
  }
  tipoLogradouro = {
    value: '',
    maxlength: '50',
    required: false,
    state: null
  }
  logradouro = {
    value: '',
    maxlength: '50',
    required: false,
    state: null
  }
  complemento = {
    value: '',
    maxlength: '50',
    required: false,
    state: null
  }
  numero = {
    value: '',
    maxlength: '20',
    required: false,
    state: null
  }
  bairro = {
    value: '',
    maxlength: '50',
    required: false,
    state: null
  }
  municipio = {
    value: '',
    maxlength: '50',
    required: false,
    state: null
  }
  uf = {
    value: '',
    maxlength: '2',
    required: false,
    state: null
  }
  cep = {
    value: '',
    maxlength: '20',
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/person/components/add/endereco-form.js